import React from 'react'
import Pointpicker from './pointpicker'

export const EventCondition = ({ formData, schema, onChange, formContext }) => {
  return (
    <div className="form-group field field-object">
      <div className="form-group field field-string">
        <label className="control-label" htmlFor={`type-${formData._id}`}>
          Type
        </label>
        <select
          id={formData._id}
          className="form-control"
          value={formData.type}
          onChange={e => onChange({ ...formData, type: e.target.value })}
        >
          <option value=""></option>
          <option value="point_checked">Point checké</option>
          <option value="points_checked">Nombre de points checkés</option>
          <option value="score">Score atteint</option>
        </select>
      </div>
      <div className="form-group field">
        {formData.type === 'point_checked' && (
          <Pointpicker
            formContext={{
              ...formContext,
              tracks: [formContext?.formData || {}]
            }}
            formData={formData.pointId || ''}
            schema={{ title: 'Point' }}
            onChange={pointId => onChange({ ...formData, pointId })}
          />
        )}
        {formData.type === 'points_checked' && (
          <>
            <div className="form-group field field-number">
              <label className="control-label" htmlFor="root_events_1_conditions_0_number">
                Nombre de points
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Nombre de points"
                value={formData.number || ''}
                onChange={e => onChange({ ...formData, number: parseInt(e.target.value) })}
              />
            </div>
          </>
        )}
        {formData.type === 'score' && (
          <>
            <div className="form-group field field-number">
              <label className="control-label" htmlFor="root_events_1_conditions_0_number">
                Score
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Score"
                value={formData.number || ''}
                onChange={e => onChange({ ...formData, number: parseInt(e.target.value) })}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
